import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlatformSettingsDomainModule } from '@p2p/platform-settings/domain';

import { PlatformSettingsApiService } from './platform-settings-api.service';

@NgModule({
    imports: [CommonModule, PlatformSettingsDomainModule],
    providers: [PlatformSettingsApiService]
})
export class PlatformSettingsApiModule {}
